import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=11f863d4&scoped=true&"
import script from "./RoleManager.vue?vue&type=script&lang=js&"
export * from "./RoleManager.vue?vue&type=script&lang=js&"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=11f863d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f863d4",
  null
  
)

export default component.exports